module.exports = __webpack_public_path__ + "img/guardian.c89aaaca.svg";